import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="refresh"
export default class extends Controller {
  static targets = ["frame"];

  connect() {
    this.frameTarget.reload();
  }
}
